import React, { useContext, useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles';

import Sidenav from '../../Sidenav/Sidenav';
import Brand from '../../Brand/Brand';
import { Switch, Hidden } from '@material-ui/core';
import { convertHexToRGB } from 'utils';
import useSettings from 'app/hooks/useSettings';
import { AppControlContext } from 'app/contexts/AppControlContext';

import { useHistory, useLocation } from 'react-router-dom';

import clsx from 'clsx';

import { Auth } from "aws-amplify";


const useStyles = makeStyles(({ palette, ...theme }) => ({
  sidenav: ({ width, primaryRGB, bgImgURL }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: width,
    boxShadow: theme.shadows[8],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top',
    backgroundSize: 'cover',
    zIndex: 111,
    overflow: 'hidden',
    color: palette.text.primary,
    transition: 'all 250ms ease-in-out',
    backgroundColor: '#006EE7'
  }),
  hideOnCompact: {
    display: 'none',
  },
  userInfo: {},
}));

const useStyles2 = makeStyles(({ palette, ...theme }) => ({
  sidenav: ({ width, primaryRGB, bgImgURL }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: width,
    boxShadow: theme.shadows[8],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top',
    backgroundSize: 'cover',
    zIndex: 111,
    overflow: 'hidden',
    color: palette.text.primary,
    transition: 'all 250ms ease-in-out',
    backgroundColor: '#ffff00'
  }),
  hideOnCompact: {
    display: 'none',
  },
  userInfo: {},
}));

const Layout1Sidenav = () => {
  const location = useLocation();
  //console.log('pathname:' + location.pathname.substring(1))

  const theme = useTheme();
  //const { isAppControl } = useContext(AppControlContext)
  const { isAppControl, setIsAppControl } = useContext(AppControlContext)

  const { settings, updateSettings } = useSettings();

  const leftSidebar = settings.layout1Settings.leftSidebar;
  const { mode } = leftSidebar;


  const getSidenavWidth = () => {
    switch (mode) {
      case 'compact':
        return 'var(--sidenav-compact-width)';
      default:
        return 'var(--sidenav-width)';
    }
  };

  const primaryRGB = convertHexToRGB(theme.palette.primary.main);
  const classes = useStyles({
    ...leftSidebar,
    width: getSidenavWidth(),
    primaryRGB,
  });
  const classes2 = useStyles2({
    ...leftSidebar,
    width: getSidenavWidth(),
    primaryRGB,
  });

  const updateSidebarMode = (sidebarSettings) => {
    updateSettings({
      layout1Settings: {
        leftSidebar: {
          ...sidebarSettings,
        },
      },
    });
  };

  const handleSidenavToggle = () => {
    updateSidebarMode({ mode: mode === 'compact' ? 'full' : 'compact' });
  };

  //AppControlボタンのリンク先振り分け
  const history = useHistory();
  const linkPath = () => {
    history.push(!isAppControl ? '/storehome' : '/home')
  }

  const [brand, setBrand] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await Auth.currentUserInfo();
        setBrand(data.username);

      } catch (e) {
        console.log("error", e);
      }
    })()
  }, []);

  if (location.pathname.substring(1) != 'shoplist') {
    return (
      <div className={clsx(!isAppControl ? classes.sidenav : classes2.sidenav, !isAppControl ? 'side-sv' : 'side-ap')}>
        <div className="flex-column relative __h-full" style={{ position: 'relative', height: '88%' }}>
          <Brand>
            <Hidden smDown>
              <Switch
                onChange={handleSidenavToggle}
                checked={leftSidebar.mode !== 'full'}
                color="secondary"
                size="small"
              />
            </Hidden>
          </Brand>
          <Sidenav />
        </div>

        {/*(() => {
          if (brand != '' && brand == 'osaka-ohsho') {
            return (
              <button
                onClick={() => { setIsAppControl(!isAppControl); linkPath(); }}
                className={clsx('btn-app_control', !isAppControl ? `ap` : `sv`)}>
                {!isAppControl ? `APP Control` : `Sales View`}
              </button>
            )
          }
        })()*/}

      </div>
    );
  } else {
    return null;
  }

};

export default React.memo(Layout1Sidenav);
